import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import makeRequest from 'utils/makeRequest';
import Slider from 'react-slick';
import s from './CricketTeamList.scss';
// eslint-disable-next-line import/first
//import { Link } from '@material-ui/core';
import Link from '../../../../../components/Link/Link';
// import ReadMoreLess from '../../../../../components_v2/common/ReadMoreLess/ReadMoreLess';
import CricketPlayerCard from './CricketPlayerCard';
import CricketRecordWidget from './CricketRecordWidget';
import MatchInfoCard from '../../../../../components_v2/common/MatchInfoCard/MatchInfoCard';
import { getMatchCenterUrl } from '../MatchCenterCard/MatchCenterCardUtils';

function getPerformanceData(
  performanceData,
  deviceType,
  performanceType = 'Team',
) {
  return (
    <ul>
      <li className={s.highlighted}>
        <strong>{performanceType}</strong>
        <strong>Played</strong>
        <strong>Win</strong>
        <strong>Lost</strong>
        {!deviceType && (
          <>
            <strong>Tie</strong>
            <strong>N/R</strong>
          </>
        )}

        <strong>Win%</strong>
      </li>
      {performanceData &&
        performanceData.map(teamstats => (
          <li key={teamstats.id}>
            <span>
              {performanceType === 'Year' ? teamstats.value : teamstats.name}
            </span>
            <span>{teamstats.matches_played}</span>
            <span>{teamstats.matches_won}</span>
            <span>{teamstats.matches_lost}</span>
            {!deviceType && (
              <>
                <span>{teamstats.matches_tied}</span>
                <span>{teamstats.no_result}</span>
              </>
            )}
            <span>{teamstats.win_percentage}</span>
          </li>
        ))}
    </ul>
  );
}
const CricketTeamList = props => {
  const {
    cricket_team_list = [],
    compTypeId = '',
    leagueId = '',
    parentId = '',
    scheduleCardUrl = '',
    teamId = '',
    tournamentName = '',
  } =
    props.sectionItem || {};
  const processMatchCardUrl = match => {
    if (match) {
      const url = getMatchCenterUrl(
        match &&
        match.participants &&
        Array.isArray(match.participants) &&
        match.participants.length > 0 &&
        match.participants[0].name
          ? match.participants[0].name
          : '',
        match &&
        match.participants &&
        Array.isArray(match.participants) &&
        match.participants.length > 1 &&
        match.participants[1].name
          ? match.participants[1].name
          : '',
        match?.event_name,
        match?.series_name,
        match?.game_id,
        match?.date,
      );
      return url;
    }
    return '';
  };
  const deviceType = props?.deviceType;
  const [showPlayer, setShowPlayer] = useState(true);
  const [scheduleList, setScheduleList] = useState(null);
  const fetchMatchScheduleData = async dataUrl => {
    const data = await makeRequest.get(dataUrl, {}, 'skipfeedengine');
    if (data && data.status === 200 && data.data) {
      if (data.data && data.data.matches) {
        if (Array.isArray(data.data.matches) && data.data.matches.length > 0) {
          data.data.matches.map(match => {
            match.cardurl = processMatchCardUrl(match);
            return match;
          });
        }
      }
      setScheduleList(data.data);
    }
  };
  useEffect(() => {
    if (scheduleCardUrl) {
      fetchMatchScheduleData(scheduleCardUrl);
    }
  }, []);
  useEffect(
    () => {
      const element = document.getElementById('playerCTA');
      const offset = 500; // Adjust this value as needed
      if (element) {
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    },
    [showPlayer],
  );

  // const seoText = cricket_team_list && cricket_team_list.writeup;
  // let planSeoText = '';
  // if (seoText) {
  //   const regex = /(<([^>]+)>)/gi;
  //   planSeoText = seoText.replace(regex, '');
  // }
  const rankingData =
    cricket_team_list &&
    cricket_team_list.stats &&
    cricket_team_list.stats.format &&
    Array.isArray(cricket_team_list.stats.format) &&
    cricket_team_list.stats.format.length > 0 &&
    cricket_team_list.stats.format.filter(
      data => data.comp_type_id === compTypeId && data.league_id === leagueId,
    )[0];
  const thumbslist =
    cricket_team_list &&
    cricket_team_list.playerthumbs &&
    cricket_team_list.playerthumbs.data;
  const defaultThumb =
    'https://static.toiimg.com/thumb/msid-81945120,width-100,height-100/81945120.jpg';
  const squadData = cricket_team_list?.squads?.squad;
  const squadDataLength = squadData && Object.values(squadData).length;
  const squadDataItem = [];
  if (squadDataLength && squadDataLength > 0) {
    delete squadData.desc;
    Object.keys(squadData).forEach(key => {
      const items = {
        short_name: squadData[key][1],
        skill_name: squadData[key][2],
        id: squadData[key][0],
      };
      squadDataItem.push(items);
    });
  }
  // trophyData
  const trophyData =
    cricket_team_list &&
    cricket_team_list.trophy_cabinet &&
    cricket_team_list.trophy_cabinet.trophy_details &&
    Array.isArray(cricket_team_list.trophy_cabinet.trophy_details) &&
    cricket_team_list.trophy_cabinet.trophy_details.length > 0 &&
    cricket_team_list.trophy_cabinet.trophy_details.filter(
      data => data.parent_id === parentId,
    )[0];
  const newTrophyArray = trophyData && trophyData.year.split(',');
  const trophyItem =
    newTrophyArray &&
    Array.isArray(newTrophyArray) &&
    newTrophyArray.map((itm, index) => <span key={index}>{itm}</span>);
  // console.log('Ashok', res);
  // Object.keys(person).forEach(key => {
  //   console.log('aaaa', person[key][1]);
  //   //delete person[key];
  // });
  const settings = {
    slidesToShow: 1.8,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    infinite: false,
    centerMode: false,
  };
  return (
    <>
      {cricket_team_list && (
        <div className={`${s.team_page} team_page`}>
          <div className={s.team_players}>
            <div className={s.team_details_block}>
              <div className={s.player_bg} />
              <div className={s.dotted_bg_left} />
              <div className={s.dotted_bg_bottom} />
              <div className={s.top_header}>
                <div className={s.team_flag}>
                  <i
                    className={`${s.icon} ${s[cricket_team_list?.short_name]}`}
                  />
                  {cricket_team_list?.name}
                </div>
                <div className={s.score_ranking}>
                  <div className={s.rank}>{rankingData?.ranking || '-'}</div>
                  <div className={s.rank_text}>
                    {rankingData?.comp_type} Ranking
                  </div>
                </div>
              </div>
              <div className={s.players_block}>
                <div className={s.player_wrap}>
                  <div className={`${s.player_details} ${s.heading}`}>
                    Squad
                  </div>
                  {squadDataItem &&
                    Array.isArray(squadDataItem) &&
                    squadDataItem.length > 0 &&
                    squadDataItem.map((items, index) => {
                      const playerkey = items && items.short_name;
                      const showPlayerIndex =
                        showPlayer && deviceType ? 6 : squadDataItem.length;
                      if (index < showPlayerIndex) {
                        return (
                          <CricketPlayerCard
                            items={items}
                            playerkey={playerkey}
                            thumbslist={thumbslist}
                            defaultThumb={defaultThumb}
                          />
                        );
                      }
                      return null;
                      // return getPlayerList(
                      //   items,
                      //   playerkey,
                      //   thumbslist,
                      //   defaultThumb,
                      // );
                    })}
                  {squadDataItem.length === 0 &&
                    cricket_team_list &&
                    cricket_team_list.players &&
                    cricket_team_list.players.player &&
                    Array.isArray(cricket_team_list.players.player) &&
                    cricket_team_list.players.player.length > 0 &&
                    cricket_team_list.players.player.map((items, index) => {
                      const playerkey = items && items.short_name;
                      const showPlayerIndex =
                        showPlayer && deviceType
                          ? 6
                          : cricket_team_list.players.player.length;
                      if (index < showPlayerIndex) {
                        // return getPlayerList(
                        //   items,
                        //   playerkey,
                        //   thumbslist,
                        //   defaultThumb,
                        // );
                        return (
                          <CricketPlayerCard
                            items={items}
                            playerkey={playerkey}
                            thumbslist={thumbslist}
                            defaultThumb={defaultThumb}
                          />
                        );
                      }
                      return null;
                    })}
                </div>
              </div>
              <div className={s.view_full}>
                {deviceType && (
                  <button
                    className="btn"
                    id="playerCTA"
                    onClick={() => setShowPlayer(!showPlayer)}
                  >
                    {showPlayer ? 'See Full Squad' : 'Hide Full Squad'}
                  </button>
                )}
              </div>
            </div>
            {/* <ReadMoreLess
              information={planSeoText}
              readMoreLengthLimit={deviceType ? 100 : 300}
              link=""
              className="abs"
            /> */}

            <div
              className={`${s.common_block} ${s.schedule_carousle} slick_UI`}
            >
              {scheduleList &&
                scheduleList.matches &&
                Array.isArray(scheduleList.matches) &&
                scheduleList.matches.length > 0 && (
                  <div className={s.ttl_view}>
                    <div className={s.ttl}>Schedule</div>
                    <Link
                      className={s.view_schedule}
                      href={`/sports/cricket/${tournamentName}/schedule`}
                    >
                      See Full Schedule
                    </Link>
                  </div>
                )}

              {scheduleList &&
                !deviceType &&
                scheduleList.matches &&
                Array.isArray(scheduleList.matches) &&
                scheduleList.matches.length > 0 && (
                  <Slider {...settings}>
                    {scheduleList.matches
                      .filter(
                        match =>
                          (teamId &&
                            match.participants &&
                            match.participants[0].id === teamId) ||
                          (teamId &&
                            match.participants &&
                            match.participants[1].id === teamId),
                      )
                      .map(match => {
                        const isLiveMatch = match && match.event_state === 'L';
                        const isUpcomingMatch =
                          match && match.event_state === 'U';
                        const isMatchEnded = match && match.event_state === 'R';
                        const seriesname = match && match.parent_series_name;
                        return (
                          <MatchInfoCard
                            isLiveMatch={isLiveMatch}
                            isUpcomingMatch={isUpcomingMatch}
                            isMatchEnded={isMatchEnded}
                            data={match}
                            seriesname={seriesname}
                          />
                        );
                      })}
                  </Slider>
                )}
              {scheduleList &&
                deviceType &&
                scheduleList.matches &&
                Array.isArray(scheduleList.matches) &&
                scheduleList.matches.length > 0 &&
                scheduleList.matches
                  .filter(
                    match =>
                      (teamId &&
                        match.participants &&
                        match.participants[0].id === teamId) ||
                      (teamId &&
                        match.participants &&
                        match.participants[1].id === teamId),
                  )
                  .map((match, index) => {
                    const isLiveMatch = match && match.event_state === 'L';
                    const isUpcomingMatch = match && match.event_state === 'U';
                    const isMatchEnded = match && match.event_state === 'R';
                    const seriesname = match && match.parent_series_name;
                    if (index < 2) {
                      return (
                        <MatchInfoCard
                          isLiveMatch={isLiveMatch}
                          isUpcomingMatch={isUpcomingMatch}
                          isMatchEnded={isMatchEnded}
                          data={match}
                          seriesname={seriesname}
                        />
                      );
                    }
                    return null;
                  })}
              {/* <MatchInfoCard
                  isLiveMatch={isLiveMatch}
                  isUpcomingMatch={isUpcomingMatch}
                  isMatchEnded={isMatchEnded}
                  data={match}
                  seriesname={seriesname}
                /> */}
              <div className={s.mob_view_schedule}>
                <Link
                  className={s.view_schedule}
                  href={`/sports/cricket/${tournamentName}/schedule`}
                >
                  See Full Schedule
                </Link>
              </div>
            </div>
            <div className={s.common_block}>
              <div className={`${s.ttl_view} ${s.ttl_view_fix}`}>
                <div className={s.ttl}>Records</div>
                <div className={s.tournament_match}>
                  {trophyItem && (
                    <div className={s.tournament}>
                      <div className={s.heading}>Tournament</div>
                      <div className={s.details}>
                        <div className={`${s.score_box} ${s.score_trophy}`}>
                          <div className={s.score_number}>
                            <span className={s.trophy}>
                              <i />
                            </span>
                            <div className={s.years}>{trophyItem}</div>
                          </div>
                          <div className={s.text}>Won</div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className={s.matches}>
                    <div className={s.heading}>Matches</div>
                    <div className={s.details}>
                      <div className={s.score_box}>
                        <div className={s.score_number}>
                          {rankingData?.overall?.matches_played || '-'}
                        </div>
                        <div className={s.text}>Played</div>
                      </div>
                      <div className={s.score_box}>
                        <div className={s.score_number}>
                          {rankingData?.overall?.matches_won || '-'}
                        </div>
                        <div className={s.text}>Win</div>
                      </div>
                      <div className={s.score_box}>
                        <div className={s.score_number}>
                          {rankingData?.overall?.matches_lost || '-'}
                        </div>
                        <div className={s.text}>Lost</div>
                      </div>
                      <div className={s.score_box}>
                        <div className={s.score_number}>
                          {rankingData?.overall?.matches_tied || '-'}
                        </div>
                        <div className={s.text}>Tied</div>
                      </div>
                      <div className={s.score_box}>
                        <div className={s.score_number}>
                          {rankingData?.overall?.no_result || '-'}
                        </div>
                        <div className={s.text}>NR</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={`${s.common_block} ${s.noborder}`}>
              <div className={`${s.ttl_view} ${s.ttl_view_fix}`}>
                <div className={s.ttl}>
                  Team {cricket_team_list.name} Records
                </div>
              </div>
              <div className={s.records_block}>
                <div className={s.records}>
                  {rankingData &&
                    rankingData.overall &&
                    rankingData.overall.top_performer &&
                    rankingData.overall.top_performer.record &&
                    Array.isArray(rankingData.overall.top_performer.record) &&
                    rankingData.overall.top_performer.record.length > 0 && (
                      <div className={s.recordsRow}>
                        {rankingData.overall.top_performer.record.map(
                          topPerformer => {
                            const title =
                              topPerformer.type === 'batting'
                                ? 'Most Runs'
                                : 'Most Wickets';
                            const label1 = topPerformer.name;
                            const label2 =
                              topPerformer.type === 'batting'
                                ? `${topPerformer.value} Runs`
                                : `${topPerformer.value} Wickets`;

                            return (
                              <CricketRecordWidget
                                title={title}
                                label1={label1}
                                label2={label2}
                              />
                            );
                          },
                        )}
                      </div>
                    )}
                  {rankingData &&
                    rankingData.overall &&
                    rankingData.overall.higest_individual_performer &&
                    rankingData.overall.higest_individual_performer.record &&
                    Array.isArray(
                      rankingData.overall.higest_individual_performer.record,
                    ) &&
                    rankingData.overall.higest_individual_performer.record
                      .length > 0 && (
                      <div className={s.recordsRow}>
                        {rankingData.overall.higest_individual_performer.record.map(
                          topPerformer => {
                            const DateFormat = topPerformer.match_date.split(
                              '/',
                            );
                            let NewDate = '';
                            if (
                              DateFormat &&
                              Array.isArray(DateFormat) &&
                              DateFormat.length === 3
                            ) {
                              NewDate = `${DateFormat[2]}-${DateFormat[1]}-${
                                DateFormat[0]
                              }`;
                            }
                            const title =
                              topPerformer.type === 'batting'
                                ? 'Highest Indiviual Score'
                                : 'Best Bowling Figures';
                            const label1 = topPerformer.name;
                            const label2 = `${topPerformer?.value} vs ${
                              topPerformer?.against?.name
                            }, ${NewDate &&
                              format(Date.parse(NewDate), 'MMM D, YYYY')}`;

                            return (
                              <CricketRecordWidget
                                title={title}
                                label1={label1}
                                label2={label2}
                              />
                            );
                          },
                        )}
                      </div>
                    )}
                </div>
              </div>
            </div>
            {rankingData &&
              rankingData.overall &&
              rankingData.overall.split_by_year &&
              rankingData.overall.split_by_year.year &&
              Array.isArray(rankingData.overall.split_by_year.year) &&
              rankingData.overall.split_by_year.year.length > 0 && (
                <div className={`${s.common_block} ${s.noborder}`}>
                  <div className={`${s.ttl_view} ${s.ttl_view_fix}`}>
                    <div className={s.ttl}>Performance By Years</div>
                  </div>
                  <div className={`${s.records_block} ${s.performance_block}`}>
                    {getPerformanceData(
                      rankingData.overall.split_by_year.year,
                      deviceType,
                      'Year',
                    )}
                  </div>
                </div>
              )}
            {rankingData &&
              rankingData.overall &&
              rankingData.overall.performance_against &&
              rankingData.overall.performance_against.team &&
              Array.isArray(rankingData.overall.performance_against.team) &&
              rankingData.overall.performance_against.team.length > 0 && (
                <div className={`${s.common_block} ${s.noborder}`}>
                  <div className={`${s.ttl_view} ${s.ttl_view_fix}`}>
                    <div className={s.ttl}>Performance Against Teams</div>
                  </div>
                  <div
                    className={`${s.records_block} ${
                      s.performance_block
                    } no_bdr_last`}
                  >
                    {getPerformanceData(
                      rankingData.overall.performance_against.team,
                      deviceType,
                      'Team',
                    )}
                  </div>
                </div>
              )}
          </div>
          {/* html for stats page */}
          {/* <div className={s.stats_container}>
            <div className={s.stats_cont}>
              <div className={`${s.stats_box} ${s.blue}`}>
                <div className={`${s.top_header}`}>
                  <div /> Highest Individual Score
                </div>
                <div className={s.score_stats}>
                  <div className={s.name_socre}>
                    <div>Rohit Shrama</div>
                    <div>116</div>
                  </div>
                  <div className={s.name_socre}>
                    <div>Rohit Shrama</div>
                    <div>116</div>
                  </div>
                  <div className={s.name_socre}>
                    <div>Rohit Shrama</div>
                    <div>116</div>
                  </div>
                </div>
              </div>
              <div className={s.seeall}>
                <Link href="/">See All</Link>
              </div>
            </div>
            <div className={s.stats_cont}>
              <div className={`${s.stats_box} ${s.orange}`}>
                <div className={`${s.top_header}`}>
                  <div /> Highest Individual Score
                </div>
                <div className={s.score_stats}>
                  <div className={s.name_socre}>
                    <div>Rohit Shrama</div>
                    <div>116</div>
                  </div>
                  <div className={s.name_socre}>
                    <div>Rohit Shrama</div>
                    <div>116</div>
                  </div>
                  <div className={s.name_socre}>
                    <div>Rohit Shrama</div>
                    <div>116</div>
                  </div>
                </div>
              </div>
              <div className={s.seeall}>
                <Link href="/">See All</Link>
              </div>
            </div>
            <div className={s.stats_cont}>
              <div className={`${s.stats_box} ${s.green}`}>
                <div className={`${s.top_header}`}>
                  <div /> Highest Individual Score
                </div>
                <div className={s.score_stats}>
                  <div className={s.name_socre}>
                    <div>Rohit Shrama</div>
                    <div>116</div>
                  </div>
                  <div className={s.name_socre}>
                    <div>Rohit Shrama</div>
                    <div>116</div>
                  </div>
                  <div className={s.name_socre}>
                    <div>Rohit Shrama</div>
                    <div>116</div>
                  </div>
                </div>
              </div>
              <div className={s.seeall}>
                <Link href="/">See All</Link>
              </div>
            </div>
          </div> */}
        </div>
      )}
    </>
  );
};
CricketTeamList.propTypes = {
  sectionItem: PropTypes.objectOf({}),
  deviceType: PropTypes.string,
};
CricketTeamList.defaultProps = {
  sectionItem: {},
  deviceType: '',
};

export default React.memo(CricketTeamList);
